import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Helmet } from "react-helmet";
import Dashboard from "./components/Dashboard/Dashboard";
import Dashboard2 from "./components/Dashboard/Dashboard2";
import CreateTemplate from "./components/Whatsapp/Create_Template";
import Chats from "./components/Whatsapp/Chats";
import CreateCampaign from "./components/Whatsapp/Create Campaign";
import UserManagement from "./components/Profile/UserManagement";
import SupportCenter from "./components/Profile/SupportCenter";
import DLTTamplate from "./components/Whatsapp/TemplateStatus";
import ProfileSetting from "./components/Profile/ProfileSetting";
import Campaign from "./components/Whatsapp/Campaign";
import NavigationBar from "./components/DesktopNav";
import Contact from "./components/Landing_Page/Landing_Contact";
import Privacy from "./components/Landing_Page/Landing_Privacy";
import TAndC from "./components/Landing_Page/Landing_T&C";
import CampaignDetails from "./components/Whatsapp/campaign_details";
import CampaignView from "./components/Whatsapp/campaign_view";
import TemplateView from "./components/Whatsapp/template_view";
import TemplateEdit from "./components/Whatsapp/Template_Edit";
import Cancellation from "./components/Landing_Page/Landing_Cancellation";
import ChatBot from "./components/Whatsapp/Chat_Bot";
import Logs from "./components/Whatsapp/Logs";
import Home from "./components/Landing_Page/Home_Page/Home_Page";
import ContactBook from "./components/Whatsapp/Contact_Book";
import WelcomePage from "./components/Profile/WelcomePage";
import TemplateLibrary from "./components/Whatsapp/TemplateLibrary";
import MyLanding from "./components/Main_Landing_Page/Main_Landing_Page";
import Setup from "./components/Profile/Setup";

import "./App.css";
// Admin imports here
import StatisticsDashboard from "./components/Admin/AdminStatic";
import Login from "./components/Admin/AdminLogin";
import { initGA, logPageView } from "./analytics";
import ChatComponent from "./components/Admin/AdminWhitelist";
import ClientCreationPage from "./components/Admin/Clients/CreateClient";
import BuyPlan from "./components/Main_Landing_Page/Buy_Plan";
import GetStarted from "./components/Main_Landing_Page/GetStarted";
import AdminSideNav from "./components/Admin/AdminSideNav";
import OrderSettings from "./components/Profile/OrderSettings";
import FacebookOnBoarding from "./components/OnBoarding/FacebookOnBoarding";
import EditLibrary from "./components/Whatsapp/LibraryEdit";
import LoginPage from "./components/Admin/WhatsAppBulkSendAdmin";
import AdminDashboard from "./components/Admin/AdminDashboard";
import ClientAccordionTable from "./components/Admin/Clients/AdminClients";
import AdminCampaigns from "./components/Admin/Clients/AdminCampaigns";
// Billing Section
import Billing from "./components/Billing/Billing";

// sign up Import
import Signup from "./components/Signup/Signup";
import About from "./components/Landing_Page/Home_Page/About";
import PricingPage from "./components/Landing_Page/Home_Page/PricingPage";
import WhatsappCampaign from "./components/Landing_Page/Home_Page/Features/WhatsappCampaign";
import AutomatedReplies from "./components/Landing_Page/Home_Page/Features/AutomatedReplies";
import PersonalizedMessage from "./components/Landing_Page/Home_Page/Features/PersonalizedMessage";
import AudianceTargating from "./components/Landing_Page/Home_Page/Features/AudianceTargating";
import ScrollToTop from "./components/Landing_Page/Home_Page/ScrollToTop";
import FreeTrial from "./components/Landing_Page/Home_Page/FreeTrial";
import GoogleOneTap from "./components/GoogleOneTapnew";


const TrackPageView = () => {
  const location = useLocation();
  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);
  return null;
};
// let beepSound = new Audio(beepSoundmp3);
// beepSound.loop = true;
// beepSound.load();
const App = () => {
  const [user, setUser] = useState(false);
  const [power, setPower] = useState("");
  const [profiles, setProfiles] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [userID, setUserID] = useState("");
  const [DeveloperID, setDeveloperID] = useState("");
  const [keyId, setkeyId] = useState("");
  const [NameAdmin, setNameAdmin] = useState();
  const [AdminRole, setAdminRole] = useState();
  const handleAdminLogout = () => {
    setIsAdmin(false);
    sessionStorage.removeItem("AdminUser");
    window.location.href = "https://www.WhatsAppBulkSend.com/";
  };
  const [Admin, setAdmin] = useState();
  useEffect(() => {
    const checkAdminUser = () => {
      const storedUser = sessionStorage.getItem("AdminUser");
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser); // Parse the JSON string

        setIsAdmin(true);
        setAdmin(parsedUser);
        setAdminRole(parsedUser.userType);
        setNameAdmin(parsedUser.adname);
      } else {
        setIsAdmin(false);
      }
    };

    checkAdminUser();
    window.addEventListener("storage", checkAdminUser);
    return () => {
      window.removeEventListener("storage", checkAdminUser);
    };
  }, []);

  const handleLogout = () => {
    setUser(false);
    sessionStorage.removeItem("user");
    window.location.href = "https://www.WhatsAppBulkSend.com/";
  };
  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");
    if (storedUser) {
      setUser(true);
      const parsedUser = JSON.parse(storedUser);
      setUserID(parsedUser.userid);
      setDeveloperID(parsedUser.devloperId);
      setkeyId(parsedUser.keyId);
      setProfiles(parsedUser);
    } else {
      // login();
      <Home onLoginClick={login} country={country} />;
    }
  }, []);

  const login = () => {
    if (process.env.NODE_ENV == "development") {
      window.location.href = `${window.location.origin}/login`;
    } else {
      window.location.href = "https://www.WhatsAppBulkSend.com/login";
    }
  };
  const signUp = () => {
    if (process.env.NODE_ENV == "development") {
      window.location.href = `${window.location.origin}/signup`;
    } else {
      window.location.href = "https://www.WhatsAppBulkSend.com/signup";
    }
  };
  useEffect(() => {
    const storedPower = sessionStorage.getItem("power");
    if (storedPower) {
      setPower(storedPower);
    }
  }, []);
  // Initialize Google Analytics
  useEffect(() => {
    initGA();
  }, []);
  
  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://whatsappbulksend.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "About Us",
        item: "https://whatsappbulksend.com/about-us",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Whatsapp-Campaign",
        item: "https://whatsappbulksend.com/whatsapp-campaign",
      },
      {
        "@type": "ListItem",
        position: 4,
        name: "Audiance-Targating",
        item: "https://whatsappbulksend.com/audiance-targating",
      },
      {
        "@type": "ListItem",
        position: 5,
        name: "Personalized-Message",
        item: "https://whatsappbulksend.com/personalized-message",
      },
      {
        "@type": "ListItem",
        position: 6,
        name: "Automated-Replies",
        item: "https://whatsappbulksend.com/automated-replies",
      },
      {
        "@type": "ListItem",
        position: 7,
        name: "Pricing-Page",
        item: "https://whatsappbulksend.com/pricing-page",
      },
      {
        "@type": "ListItem",
        position: 8,
        name: "PrivacyPolicy",
        item: "https://www.whatsappbulksend.com/PrivacyPolicy",
      },
      {
        "@type": "ListItem",
        position: 9,
        name: "Terms & Conditions",
        item: "https://www.whatsappbulksend.com/terms&conditions",
      },
    ],
  };

  const [country, setCountry] = useState("");
  useEffect(() => {
    const storedCountry = sessionStorage.getItem("userCountry");
    if (!storedCountry) {
      // If no country in session storage, fetch location from API
      const fetchLocation = async () => {
        try {
          const response = await axios.get(
            `https://api.ipgeolocation.io/ipgeo?apiKey=1e4cf2d0a0ee4ebe92e18c3e52000ebf`
          );
          const userCountry = response.data.country_code2;
          setCountry(userCountry);
          sessionStorage.setItem("userCountry", userCountry);
        } catch (error) {
          console.error("Error fetching geolocation data:", error);
          setCountry("Other");
        }
      };
      fetchLocation();
    } else {
      // If country is stored in session storage, use it
      setCountry(storedCountry);
    }
  }, []);
  // Function to handle manual country change from dropdown
  const handleCountryChange = (selectedCountry) => {
    setCountry(selectedCountry);
    sessionStorage.setItem("userCountry", selectedCountry);
  };
  const handleGoogleResponse = async (response) => {
    try {
      const credential = response.credential;
      if (!credential) return;


      const base64Url = credential.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const decodedData = JSON.parse(atob(base64));

      const googleUser = {
        name: decodedData.name,
        email: decodedData.email,
        picture: decodedData.picture,
        google_id: decodedData.sub, // IMPORTANT
      };

      const [firstName, ...rest] = googleUser.name.split(" ");
      const lastName = rest.join(" ");

      const basicAuth = btoa("BUMPPY_SSO_SgLjvARJ5LbX:tGhAlPHEkx1McBnkw43vXUXs44i744jQbbjU1ODHB5SIRtSDFYaYF1yeGFJBYlZq");

      const registerResponse = await fetch(
        "https://auth.seobix.com/api/Auth/register2",
        {
          method: "POST",
          headers: {
            "Accept": "*/*",
            "Content-Type": "application/json",
            "Authorization": `Basic ${basicAuth}`,
          },
          body: JSON.stringify({
            username: googleUser.email,
            password: googleUser.google_id, // or any generated value
            firstName:googleUser.name,
            lastName:googleUser.name,
            dob: "",
            gender: "",
            country: "91",
            latitude: "",
            longitude: "",
            device: "web",
            callback: "",
            productId: "8",
            login_with: "google",
            google_id: googleUser.google_id,
            display_img:googleUser.picture,
          }),
        }
      );

      const registerData = await registerResponse.json();
      console.log("Register API:", registerData);

      // ❗ API returns 200 but status=401 in body
      if (registerData.status === "401") {
        console.warn("User already exists or unauthorized, continuing login");
      }

      // =========================
      // 2️⃣ IDENTITY / LOGIN API
      // =========================
      const identityResponse = await fetch(
        "https://auth.seobix.com/api/Auth/identityGoogle",
        {
          method: "POST",
          headers: {
            "Accept": "*/*",
            "Content-Type": "application/json-patch+json",
             "Authorization": `Basic ${basicAuth}`,
          },
          body: JSON.stringify({
            email: googleUser.email,
            latitude: null,
            longitude: null,
            device: "web",
            country: "+91",
            productId: "8",
            callback: null,
          }),
        }
      );

      const identityData = await identityResponse.json();
      console.log("Identity API:", identityData);


      localStorage.setItem("accessToken", identityData.accessToken);
      localStorage.setItem("refreshToken", identityData.refreshToken);
      localStorage.setItem("userId", identityData.userId);


      if (window.google?.accounts?.id) {
        window.google.accounts.id.cancel();
      }

      const urlParams = new URLSearchParams(window.location.search);
      const callbackUrl = urlParams.get("callback");

      if (callbackUrl && identityData?.accessToken) {
        const url = new URL(callbackUrl);

        url.searchParams.set("accessToken", identityData.accessToken);



        window.location.href = url.toString();
      }

    } catch (err) {
      console.error("Google Login Error:", err);
    }
  };
  return (
    <Router>
     <ScrollToTop/>
      <TrackPageView />

      <div>
        {/* Admin */}
  <GoogleOneTap onSuccess={handleGoogleResponse} />
        <Routes>
          {" "}
          <Route path="/Admin" element={<LoginPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
        </Routes>
        {isAdmin && (
          <>
            <AdminSideNav
              NameAdmin={NameAdmin}
              AdminRole={AdminRole}
              Admin={Admin}
              logout={handleAdminLogout}
            />
            <Routes>
              <Route
                path="/Admin/billing/:id"
                element={<StatisticsDashboard Admin={Admin} />}
              />
              <Route
                path="/Admin/dashboard"
                element={<AdminDashboard Admin={Admin} />}
              />
              <Route
                path="/Admin/whatsapp"
                element={<ClientAccordionTable Admin={Admin} />}
              />
              <Route
                path="/Admin/WhatsAppUser"
                element={<AdminCampaigns Admin={Admin} />}
              />
              <Route
                path="/admin/Whitelist"
                element={<ChatComponent Admin={Admin} />}
              />
              <Route
                path="/admin/createclient"
                element={<ClientCreationPage Admin={Admin} />}
                z
              />
            </Routes>
          </>
        )}

        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(breadcrumbData)}
          </script>
        </Helmet>
        <Routes>
          {!user && (
            <>
              <Route path="/get" element={<MyLanding onLoginClick={login} />} />
              <Route
                path="/get/BuyPlan"
                element={<BuyPlan onLoginClick={login} />}
              />

              <Route
                path="/get/GetStarted"
                element={<GetStarted onLoginClick={login} />}
              />

              <Route
                path="/"
                element={
                  <Home
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />

              <Route
                path="/contact"
                element={
                  <Contact
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />

              <Route
                path="/PrivacyPolicy"
                element={
                  <Privacy
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />
              <Route
                path="/terms&conditions"
                element={
                  <TAndC
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />

              <Route
                path="/about-us"
                element={
                  <About
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />

              <Route
                path="/pricing-page"
                element={
                  <PricingPage
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />

              <Route
                path="/whatsapp-campaign"
                element={
                  <WhatsappCampaign
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />

              <Route
                path="/automated-replies"
                element={
                  <AutomatedReplies
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />

              <Route
                path="/personalized-message"
                element={
                  <PersonalizedMessage
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />

              <Route
                path="/audiance-targating"
                element={
                  <AudianceTargating
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />

                  <Route
                path="/free-trial"
                element={
                  <FreeTrial
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />

              <Route
                path="/Cancellation"
                element={
                  <Cancellation
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />
            </>
          )}
        </Routes>
        {user ? (
          <>
            <NavigationBar
              setUser={setUser}
              handleLogout={handleLogout}
              userID={userID}
            />
            <div style={{ flex: 1, paddingLeft: "145px" }}>
              <Routes>
                {power === "1" ? (
                  <>
                    <Route
                      path="/Dashboard"
                      element={
                        <Dashboard
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Dashboard2"
                      element={
                        <Dashboard2
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Create-Template"
                      element={
                        <CreateTemplate
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp"
                      element={
                        <Chats
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/ContactBook"
                      element={
                        <ContactBook
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/ChatBot"
                      element={
                        <ChatBot
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/ChatBotStop"
                      element={
                        <ChatBot
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Campaign"
                      element={
                        <CreateCampaign
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Template"
                      element={
                        <DLTTamplate
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Manage"
                      element={
                        <Campaign
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Logs"
                      element={
                        <Logs
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/TemplateLibrary"
                      element={
                        <TemplateLibrary
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/TemplateLibrary/Edit"
                      element={
                        <EditLibrary
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile"
                      element={
                        <ProfileSetting
                          profiles={profiles}
                          power={power}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/Setting"
                      element={
                        <OrderSettings
                          profiles={profiles}
                          power={power}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />

                  
                    <Route
                      path="/Profile/Setup"
                      element={
                        <Setup
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/UserManagement"
                      element={
                        <UserManagement
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/SupportCenter"
                      element={
                        <SupportCenter
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/CampaignDetails"
                      element={
                        <CampaignDetails
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Manage/CampaignView"
                      element={
                        <CampaignView
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/TemplateView"
                      element={
                        <TemplateView
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Template/TemplateEdit"
                      element={
                        <TemplateEdit
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/WelcomePage"
                      element={
                        <WelcomePage
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Billing"
                      element={
                        <Billing
                          userID={userID}
                          profiles={profiles}
                          keyId={keyId}
                        />
                      }
                    />
                    
                    <Route
                      path="/WhatsApp/Onboarding"
                      element={
                        <FacebookOnBoarding
                          userID={userID}
                          profiles={profiles}
                        />
                      }
                    />
                  </>
                ) : (
                  <>
                    {/* <Navigate to="/Profile" replace /> */}
                   
                    <Route
                      path="/Profile"
                      element={
                        <ProfileSetting
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                   
                    <Route
                      path="/Profile/Setup"
                      element={
                        <Setup
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/WelcomePage"
                      element={
                        <WelcomePage
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/UserManagement"
                      element={
                        <UserManagement
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    
                  </>
                )}
              </Routes>
            </div>
          </>
        ) : (
          <Routes>
            {/* <Route path="/" element={<Login login={login} />} /> */}
          </Routes>
        )}
      </div>
    </Router>
  );
};

export default App;
